import React from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { formatDate } from "utils/format";

const JobPreferencesSection = () => {
  const { selectedTalent } = useSelector((state: any) => state.companyTalent);
  const navigate = useNavigate();

  return (
    <>
      <div className="mb-8 px-2">
        <h5 className="mb-2 text-sm alu-text-base-2 font-bold">希望する条件</h5>
        <div className="flex text-sm leading-[21px] mb-2 gap-2">
          <p className="shrink-0 min-w-[5rem] alu-text-base-1">条件</p>
          <p className="text-sm alu-text-base-2">
            {selectedTalent?.talent?.expected_condition ? selectedTalent?.talent?.expected_condition : 'ー'}
          </p>
        </div>

        <div className='mb-2'>
          <div className="flex text-sm leading-[21px] mb-1 gap-2">
            <p className="shrink-0 min-w-[5rem] alu-text-base-1">雇用形態</p>
            <p className="text-sm alu-text-base-2">
              {selectedTalent?.talent?.working_style_1?.label ? "第一希望：" + selectedTalent?.talent?.working_style_1?.label : 'ー'}
            </p>
          </div>
          {selectedTalent?.talent?.working_style_2?.label &&
            <div className="flex text-sm leading-[21px] mb-1 gap-2">
              <p className="shrink-0 min-w-[5rem] alu-text-base-1"></p>
              <p className="text-sm alu-text-base-2">
                第二希望：{selectedTalent?.talent?.working_style_2?.label ? selectedTalent?.talent?.working_style_2?.label : 'ー'}
              </p>
            </div>
          }
          {selectedTalent?.talent?.working_style_3?.label &&
            <div className="flex text-sm leading-[21px] gap-2">
              <p className="shrink-0 min-w-[5rem] alu-text-base-1"></p>
              <p className="text-sm alu-text-base-2">
                第三希望：{selectedTalent?.talent?.working_style_3?.label ? selectedTalent?.talent?.working_style_3?.label : 'ー'}
              </p>
            </div>
          }
        </div>

        <div>
          <div className="flex text-sm leading-[21px] gap-2 mb-1">
            <p className="shrink-0 min-w-[5rem] alu-text-base-1">勤務地</p>
            <p className="text-sm alu-text-base-2">
              {selectedTalent?.talent?.preferred_city_1?.label ? "第一希望：" + selectedTalent?.talent?.preferred_city_1?.label : 'ー'}
            </p>
          </div>
          {selectedTalent?.talent?.preferred_city_2?.label &&
            <div className="flex text-sm leading-[21px] mb-1 gap-2">
              <p className="shrink-0 min-w-[5rem] alu-text-base-1"></p>
              <p className="text-sm alu-text-base-2">
                第二希望：{selectedTalent?.talent?.preferred_city_2?.label ? selectedTalent?.talent?.preferred_city_2?.label : 'ー'}
              </p>
            </div>
          }
          {selectedTalent?.talent?.preferred_city_3?.label &&
            <div className="flex text-sm leading-[21px] gap-2">
              <p className="shrink-0 min-w-[5rem] alu-text-base-1"></p>
              <p className="text-sm alu-text-base-2">
                第三希望：{selectedTalent?.talent?.preferred_city_3?.label ? selectedTalent?.talent?.preferred_city_3?.label : 'ー'}
              </p>
            </div>
          }
        </div>
      </div>

      <div className="px-2 mb-8">
        <h5 className="text-sm alu-text-base-2 font-bold mb-2">見ている求人</h5>
        {
          selectedTalent?.list_job_interested?.length > 0 ?
          selectedTalent?.list_job_interested?.map((job: any, idx: number) => (
          <p key={idx} onClick={() => navigate(`/company/job/detail/${job?.id}`)} className={`w-fit cursor-pointer text-sm alu-text-base-2 ${idx !== selectedTalent?.list_job_interested.length - 1 ? 'mb-2' : ''} underline hover:text-[#FF861A]`}>
            {job?.title}
          </p>
        )) : 'ー'
        }
      </div>

      {!selectedTalent?.is_active &&
      <>
        <div className="px-2 mb-8">
          <h5 className="text-sm alu-text-base-2 font-bold mb-2">退会理由</h5>
          <p className="text-left flex-1 text-sm alu-text-base-2">
          {selectedTalent?.cancel_reason ? selectedTalent?.cancel_reason : 'ー'} 
          </p>
        </div>
        <div className="px-2">
          <h5 className="text-sm alu-text-base-2 font-bold mb-2">退会日</h5>
          <p className="text-left flex-1 text-sm alu-text-base-2">
          {selectedTalent?.cancel_date ? formatDate(selectedTalent?.cancel_date): 'ー'}
          </p>
        </div>
      </>
      }
    </>
  )
}

export default JobPreferencesSection